module.exports = {"modelSvg":"assets/melanocyte.svg","species":["organelles/melanosome.yml","organelles/dots.yml","organelles/hexagon.yml","organelles/g-protein.yml","organelles/g-protein-body.yml","organelles/g-protein-part.yml"],"calculatedProperties":{"lightness":{"ratio":{"numerator":{"count":{"species":"melanosome","rules":{"fact":{"not":"isDark"}}}},"denominator":{"count":{"species":"melanosome","rules":{"fact":"isDark"}}}}}},"hotStart":1000}


//////////////////
// WEBPACK FOOTER
// ./src/cell-models/cell.json
// module id = 326
// module chunks = 0